export const cities = [

    {
        value: "Podgorica",
        item: "Podgorica"
    },
    {
        value: "Andrijevica",
        item: "Andrijevica"
    },
    {
        value: "Bar",
        item: "Bar"
    },
    {
        value: "Berane",
        item: "Berane"
    },
    {
        value: "Bijelo Polje",
        item: "Bijelo Polje"
    },
    {
        value: "Budva",
        item: "Budva"
    },
    {
        value: "Cetinje",
        item: "Cetinje"
    },
    {
        value: "Danilovgrad",
        item: "Danilovgrad"
    },
    {
        value: "Gusinje",
        item: "Gusinje"
    },
    {
        value: "Herceg Novi",
        item: "Herceg Novi"
    },
    {
        value: "Kolašin",
        item: "Kolašin"
    },
    {
        value: "Kotor",
        item: "Kotor"
    },
    {
        value: "Mojkovac",
        item: "Mojkovac"
    },
    {
        value: "Nikšić",
        item: "Nikšić"
    },
    {
        value: "Petnjica",
        item: "Petnjica"
    },
    {
        value: "Plav",
        item: "Plav"
    },
    {
        value: "Pljevlja",
        item: "Pljevlja"
    },
    {
        value: "Plužine",
        item: "Plužine"
    },
    {
        value: "Rožaje",
        item: "Rožaje"
    },
    {
        value: "Šavnik",
        item: "Šavnik"
    },
    {
        value: "Tivat",
        item: "Tivat"
    },
    {
        value: "Tuzi",
        item: "Tuzi"
    },
    {
        value: "Ulcinj",
        item: "Ulcinj"
    },
    {
        value: "Žabljak",
        item: "Žabljak"
    }
];
